// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { VirtualTestingAreaId } from './VirtualTestingAreaId'
import {
  VirtualTestingAreaNavigation,
  VirtualTestingAreaNavigationIcon,
} from './VirtualTestingAreaNavigation'
import { VirtualTestingAreaRoutes } from './VirtualTestingAreaRoutes'

const LazyVirtualTestingComponent = lazy(() => import('./VirtualTestingArea'))

const VirtualTestingComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyVirtualTestingComponent />
  </SuspenseLoadingWrapper>
)

export const VirtualTestingArea = {
  id: VirtualTestingAreaId,
  requiredRight: BoumRight.AREA_ADMIN_PANEL_VV_DAVT,
  Icon: VirtualTestingAreaNavigationIcon,
  NavigationComponent: VirtualTestingAreaNavigation,
  route: {
    path: VirtualTestingAreaRoutes.route,
    component: VirtualTestingComponent,
  },
}
